require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-wmfs-software-dev.json") })
        }
      }, "path---study-wmfs-software-dev");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-wmfs-software-dev!./.cache/json/study-wmfs-software-dev.json
// module id = 936
// module chunks = 231608221292675